import React from 'react';

import style from './Divider.scss';

const Divider = () => <hr className={style.divider} />;

export default Divider;
